module.exports = __webpack_public_path__ + "static/media/Pattern_Picture_Manager_RGB.46f1a8a8.png";